<template>
  <section class="case-creation__step case-creation__patient-information">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-patient-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Patient Information</h3>
          <div v-if="getCaseInformation?.is_stat && !showStatCase()">
            <span class="is_stat">STAT</span>
          </div>
        </div>
      </div>

      <div class="case-creation__body pb-0" v-if="getPatientInformation">
        <div class="vue-data">
          <el-row :gutter="20">
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">First Name</h4>
                <p class="value">{{ formattedFirstName }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Middle Name</h4>
                <p class="value">{{ formattedMiddleName }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Last Name</h4>
                <p class="value">{{ formattedLastName }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Gender</h4>
                <p class="value">{{ getValue("gender") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Date of Birth</h4>
                <p class="value">{{ formattedDateOfBirth }}</p>
              </div>
            </el-col>

            <!-- <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">EMR</h4>
                <p class="value">{{ getPatientInformation.emr || "--" }}</p>
              </div>
            </el-col> -->
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Mobile Number</h4>
                <p class="value">{{ getValue("home_phone") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Phone Number</h4>
                <p class="value">{{ getValue("work_phone") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Email</h4>
                <p class="value">{{ getValue("email") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
              <div class="input-value view-cases">
                <h4 class="name">Address Line 1</h4>
                <p class="value">{{ getValue("address_line_1") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
              <div class="input-value view-cases">
                <h4 class="name">Address Line 2</h4>
                <p class="value">{{ getValue("address_line_2") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">County</h4>
                <p class="value">{{ getValue("county") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Zip</h4>
                <p class="value">{{ getValue("zip") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" v-if="!isBillingUser" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Zip Extension</h4>
                <p class="value">{{ getValue("zip_extension") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">State</h4>
                <p class="value">{{ getValue("state") }}</p>
              </div>
            </el-col>

            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">City</h4>
                <p class="value">{{ getValue("city") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Race</h4>
                <p class="value">{{ getValue("race") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Ethnicity</h4>
                <p class="value">{{ getValue("ethnicity") }}</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Medical Record Id</h4>
                <p class="value">{{ getValue("medical_record_id") }}</p>
              </div>
            </el-col>
            <el-col
              :xl="3"
              :lg="4"
              :md="8"
              :sm="12"
              :xs="12"
              v-if="getPatientInformation?.pregnant"
            >
              <div class="input-value view-cases">
                <h4 class="name">Pregnancy</h4>
                <p class="value">
                  {{ getPatientInformation?.pregnant ? "Yes" : "No" }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import GlobalHelper from "@/mixins/GlobalHelper";

export default {
  mixins: [UserPermissionsHelper, GlobalHelper],
  computed: {
    ...mapGetters("orders", ["getCaseInformation"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    // Simplified getPatientInformation computed property
    getPatientInformation() {
      return this.getCaseInformation?.patient_info || null;
    },
    // Pre-computed formatted values to avoid repeated function calls in template
    formattedFirstName() {
      return this.getPatientInformation?.first_name
        ? this.convertToUppercase(this.getPatientInformation.first_name)
        : "--";
    },
    formattedMiddleName() {
      return this.getPatientInformation?.middle_name
        ? this.convertToUppercase(this.getPatientInformation.middle_name)
        : "--";
    },
    formattedLastName() {
      return this.getPatientInformation?.last_name
        ? this.convertToUppercase(this.getPatientInformation.last_name)
        : "--";
    },
    formattedDateOfBirth() {
      return this.getPatientInformation?.date_of_birth
        ? this.formatDate(this.getPatientInformation.date_of_birth)
        : "--";
    },
  },
  methods: {
    // Helper to get value or default
    getValue(field) {
      if (!field || typeof field !== "string") return "--";
      const value = this.getPatientInformation?.[field];
      // Ensure we always return a string primitive, not an object
      if (value === null || value === undefined) return "--";
      if (typeof value === "object") return JSON.stringify(value);
      return String(value) || "--";
    },
  },
};
</script>
<style>
.is_stat {
  height : 18px;
  width: 41px;
  color: #BF1B39;
  font-weight: bold;
  padding-left: 8px;
}</style>
 